import { combineLatest } from 'rxjs';
import { spreadMap } from '@ardoq/rxbeach';
import {
  featureOperations,
  Features,
  type FeatureContext,
} from '@ardoq/features';
import { featureContext$ } from 'streams/featureContext$';
import { hasWriteAccess$ } from 'streams/hasWriteAccess$';
import { getStartableTours, type TourId } from '@ardoq/product-tours';
import { buildStartProductTourCommand } from 'aiControlledCommands/productTours/startProductTour/command';
import { toursWithSatisfiedDataGates$ } from 'productTours/tourDataGate';
import { productTourStatus$, type TourState } from '@ardoq/product-tours-host';
import type { AiControlledCommand } from 'aiControlledCommands/types';

export const toStartProductTourCommands = (
  featureContext: FeatureContext,
  hasWriteAccess: boolean,
  toursWithSatisfiedDataGates: readonly TourId[],
  tourState: TourState
): AiControlledCommand[] => {
  if (
    !featureOperations.hasFeature(featureContext, Features.PRODUCT_TOUR_AGENT)
  ) {
    return [];
  }
  const availableTours = getStartableTours({
    featureContext,
    hasWriteAccess,
    hostApp: 'ardoq-front',
    toursWithSatisfiedDataGates,
  });
  if (availableTours.length === 0) {
    return [];
  }
  return [buildStartProductTourCommand(availableTours, tourState)];
};

export const availableCommands$ = combineLatest([
  featureContext$,
  hasWriteAccess$,
  toursWithSatisfiedDataGates$,
  productTourStatus$,
]).pipe(spreadMap(toStartProductTourCommands));
